export const faqData = [
  {
    id: 1,
    question: "What is an EMI, and how is it calculated?",
    answer:
      "EMI stands for Equated Monthly Installment, which is the fixed amount you pay monthly towards repaying your loan. It includes both the principal and interest components. ",
  },
  {
    id: 2,
    question: "How does my credit score affect EMI?",
    answer:
      "A higher credit score (750 and above) can help you secure lower interest rates, which reduces your EMI and total repayment amount. A lower credit score may result in higher interest rates and EMIs.",
  },
  {
    id: 3,
    question: "Can I reduce my EMI during the loan tenure?",
    answer:
      "Yes, you can reduce your EMI by opting for prepayment or foreclosure of the loan. Kotak Mahindra Bank allows prepayment with minimal or no charges after a certain period.",
  },
  {
    id: 4,
    question: "What is the difference between EMI and APR?",
    answer:
      "EMI is the monthly payment you make towards your loan, while APR (Annual Percentage Rate) includes the interest rate and additional fees like processing charges. APR gives a more accurate picture of the total loan cost.",
  },
  {
    id: 5,
    question: "What happens if I miss an EMI payment?",
    answer:
      "Missing an EMI payment can attract late payment penalties and negatively impact your credit score. Always ensure timely payments to avoid additional costs and maintain a good credit history.",
  },
  {
    id: 6,
    question: "How can I use MinEMI’s EMI Calculator effectively?",
    answer:
      "Use MinEMI’s EMI Calculator to input your loan amount, interest rate, and tenure to get accurate EMI estimates. This helps you plan your finances and choose the best loan option for your needs.",
  },
];
